import { capabilities, setModifierManager } from '@ember/modifier';

import type { ModifierLike } from '@glint/template';

interface Args {
	positional: unknown[];
	named: Record<string, unknown>;
}

type OnChangeFn = (element: HTMLElement) => void;

// Copied functionality from @ember/render-modifiers
// See more at https://github.com/ember-template-lint/ember-template-lint/blob/master/docs/rule/no-at-ember-render-modifiers.md

const DidInsertModifier = setModifierManager(
	() => ({
		capabilities: capabilities('3.22', { disableAutoTracking: true }),

		createModifier() {
			// nothing
		},

		installModifier(_state: unknown, element: HTMLElement, args: Args) {
			const fn = args.positional[0] as OnChangeFn;
			fn(element);
		},

		updateModifier() {
			// nothing
		},
		destroyModifier() {
			// nothing
		},
	}),
	class DidInsertModifier {},
);

type Modifier = ModifierLike<{
	Args: { Positional: [handler: (node: HTMLElement) => void] };
	Return: void;
}>;

export default DidInsertModifier as unknown as Modifier;
